import { isAxiosError } from 'axios';
import { ExternalToast, toast } from 'sonner';

export const handleErrorToast = (error: Error, data?: ExternalToast) => {
  if (isAxiosError(error)) {
    toast.error(error.response?.data.message ?? error.message, data);
    return;
  }
  toast.error(error.message, data);
};
